import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmorphicService } from '../../services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../interfaces/controller/CoverpathControllerInterface';
import { Person } from '../../../../common/js/customer/Person';
import { Subscription } from 'rxjs';

@Component({
  moduleId: module.id,
  selector: 'unauthorized',
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent {
  headerText = `We can't locate the application you're looking for.`;
  controller: CoverpathControllerInterface;
  isCoverpathClient: boolean = true;
  private routeSub: Subscription;
  wasCancelled: boolean = false;

  constructor(private amorphicService: AmorphicService, private router: Router, private route: ActivatedRoute) {
    this.controller = amorphicService.controller as CoverpathControllerInterface;
    this.isCoverpathClient = this.controller.isCoverpathClient;
  }

  ngOnInit() {
    this.routeSub = this.route.queryParams.subscribe(async (param) => {
      if (param.wasCancelled === 'true') {
        this.wasCancelled = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  emailAdvisor(): void {
    window.open(`mailto:${this.primaryAgentEmail}`);
  }

  routeTo(route: string): void {
    this.router.navigate([route]);
  }

  private get primaryAgentEmail(): string {
    let agentProfile: Person;
    try {
      agentProfile = this.controller.customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent.person;
    } catch (error) {
      this.amorphicService.amorphicLogError(
        'UnauthorizedComponent',
        'primaryAgentEmail',
        'Page was accessed with missing Application information',
        error
      );
      return undefined;
    }

    return agentProfile.email;
  }
}
